import React from "react"
import { competitionTile } from "./plannerLabels"
import { newCompetition } from "./proposalForm"
import { SourcePill } from "./ProposalEventFields"
import { sourcePill } from "./proposalHistory"
import ProposeCompetitions from "./ProposeCompetitions"

const DRAW_MODELS = [{ key: "eliminatory", name: "Eliminatory" }, { key: "groups", name: "Groups" }]
const choices = (list, empty) => [<option key="" value="">{empty}</option>,
  ...(list || []).map(item => <option key={String(item.key)} value={String(item.key)}>{item.name || String(item.key)}</option>)]

// The Competitions tab (B3 pinned decision Q5; tickets 18, 25): level, game type, format and Main List capacity only. WildCards take
// the system default and every competition starts with the event, both set at publish; fees are set on the event, so the fees area
// is inactive. Competitions are informative for the organizer: changing them keeps a confirmation (ticket 16).
export default function ProposalCompetitions({ competitions, errors, settings, sourceOf, disabled, onChange, propose }) {
  const change = (key, fields) => onChange(competitions.map(competition => (competition.key === key ? { ...competition, ...fields } : competition)))
  const remove = key => onChange(competitions.filter(competition => competition.key !== key))
  return <div className="ep-stack ep-gap">
    {!competitions.length && <p className="ep-meta mb-0">No competitions yet. A draft can be sent without them; they are needed to publish.</p>}
    {competitions.map(competition => {
      const tile = competitionTile({ level: competition.level === "" ? null : competition.level, gameType: competition.gameType })
      const id = "competition-" + competition.key
      const select = (name, label, list, empty) => <div className="ep-field">
        <label htmlFor={`${id}-${name}`}>{label}</label>
        <select id={`${id}-${name}`} className="form-control" value={competition[name]} disabled={disabled}
          onChange={event => change(competition.key, { [name]: event.target.value })}>{choices(list, empty)}</select>
      </div>
      return <div role="group" aria-label={`Competition ${tile}`} className="ep-competition" key={competition.key}>
        <div className="ep-field-head"><b>{tile}</b><SourcePill source={competition.source ? sourcePill(competition.source)
          : competition.id ? sourceOf("competitions." + competition.id) : null} /></div>
        <div className="ep-competition-fields">
          {select("level", "Level", settings.levels, "Level")}
          {select("gameType", "Game type", settings.gameTypes, "Game type")}
          {select("drawModel", "Format", settings.drawModels?.length ? settings.drawModels : DRAW_MODELS, "Format")}
          <div className="ep-field">
            <label htmlFor={`${id}-mlMaxNumber`}>Main List capacity</label>
            <input id={`${id}-mlMaxNumber`} className="form-control" type="number" min="1" step="1" value={competition.mlMaxNumber} disabled={disabled}
              aria-invalid={Boolean(errors["competitions." + competition.key])} onChange={event => change(competition.key, { mlMaxNumber: event.target.value })} />
          </div>
          {!disabled && <button type="button" className="btn btn-link btn-sm text-danger" onClick={() => remove(competition.key)}
            aria-label={`Remove competition ${tile}`}>Remove</button>}
        </div>
        {errors["competitions." + competition.key] && <small className="text-danger">{errors["competitions." + competition.key]}</small>}
      </div>
    })}
    {!disabled && <button type="button" className="btn btn-light align-self-start" onClick={() => onChange([...competitions, newCompetition()])}>
      <i className="bx bx-plus" aria-hidden="true" /> Add competition</button>}
    {!disabled && propose && <ProposeCompetitions {...propose} onAdd={lines => onChange([...competitions, ...lines])} />}
    <div className="ep-fees-inactive" aria-disabled="true">
      <span className="ep-label">Fees</span>
      <p className="mb-0">Fees will be set as part of tournament proposals in a future release.</p>
    </div>
  </div>
}
